module.exports = __webpack_public_path__ + "img/meeting-banner.15c77fd6.webp";